import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { ROTULO_CONDUCAO } from '../components/AlertasConducaoPopup'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

const ICONES: any = {
  entrada_cerca:'📍', saida_cerca:'📍', area_proibida:'🚫',
  fora_horario:'🕐', excesso_velocidade:'⚡', ignicao_ligada:'🔑',
  ignicao_desligada:'🔑', bateria_baixa:'🔋', sem_comunicacao:'📵',
  manutencao_hodometro:'🔧', manutencao_data:'📅', panico:'🆘',
  colisao:'💥', corte_energia:'🔌', frenagem_brusca:'🛑', aceleracao_brusca:'🚀', curva_brusca:'↪️'
}

const CORES: any = {
  entrada_cerca:'azul', saida_cerca:'amarelo', area_proibida:'vermelho',
  fora_horario:'amarelo', excesso_velocidade:'vermelho', ignicao_ligada:'verde',
  ignicao_desligada:'cinza', bateria_baixa:'amarelo', sem_comunicacao:'vermelho',
  manutencao_hodometro:'roxo', manutencao_data:'roxo', panico:'vermelho',
  colisao:'vermelho', corte_energia:'amarelo', frenagem_brusca:'amarelo', aceleracao_brusca:'amarelo', curva_brusca:'amarelo'
}

const rotuloTipo = (t: string) => ROTULO_CONDUCAO[t]?.rotulo || (t || '').replace(/_/g,' ')
const erroMsg = (e: any) => e?.response?.data?.erro || 'Erro ao falar com o servidor'


// ---------------------------------------------------------------------------------------------
// Avisos de conducao: o administrador escolhe quais tipos avisam e o intervalo minimo entre dois avisos do mesmo tipo no mesmo veiculo
// ---------------------------------------------------------------------------------------------
function ConfigConducao({ aoFechar }: { aoFechar: () => void }) {
  const [dados, setDados] = useState<any>(null)
  const [erro, setErro] = useState('')
  const [salvando, setSalvando] = useState(false)
  const [ok, setOk] = useState(false)
  useEffect(() => { axios.get(`${API}/alertas-conducao/config`).then(r => setDados(r.data)).catch(e => setErro(erroMsg(e))) }, [])
  const mudar = (tipo: string, patch: any) => { setOk(false); setDados((d: any) => ({ ...d, tipos: d.tipos.map((t: any) => t.tipo === tipo ? { ...t, ...patch } : t) })) }
  const salvar = async () => {
    setSalvando(true); setErro(''); setOk(false)
    try {
      const tipos: any = {}; dados.tipos.forEach((t: any) => { tipos[t.tipo] = { ativo: t.ativo, intervalo_min: Number(t.intervalo_min) } })
      await axios.put(`${API}/alertas-conducao/config`, { tipos }); setOk(true)
    } catch (e) { setErro(erroMsg(e)) } finally { setSalvando(false) }
  }
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div className="card" role="dialog" aria-label="Avisos de condução" style={{ width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
          <h3>⚙️ Avisos de condução</h3>
          <button className="btn btn-ghost" aria-label="Fechar" style={{ padding:'4px 8px' }} onClick={aoFechar}>✕</button>
        </div>
        <p style={{ fontSize:12, color:'#94a3b8', marginBottom:12 }}>Escolha o que gera aviso na tela e no app para quem tem permissão de ver alertas. Com o aviso desligado o evento continua contando no ranking.</p>
        {erro && <div role="alert" style={{ color:'#f87171', fontSize:12, marginBottom:8 }}>⚠️ {erro}</div>}
        {!dados ? (!erro && <div style={{ color:'#64748b' }}>Carregando...</div>) : (
          <>
            {dados.tipos.map((t: any) => (
              <div key={t.tipo} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 0', borderBottom:'1px solid rgba(45,65,102,0.4)', flexWrap:'wrap' }}>
                <label style={{ display:'flex', alignItems:'center', gap:8, flex:'1 1 200px', cursor: dados.pode_editar ? 'pointer' : 'default' }}>
                  <input type="checkbox" aria-label={`Avisar ${t.rotulo}`} checked={t.ativo} disabled={!dados.pode_editar} onChange={e => mudar(t.tipo, { ativo: e.target.checked })} />
                  <span style={{ fontSize:13 }}>{t.icone} {t.rotulo}</span>
                </label>
                <label style={{ fontSize:11, color:'#94a3b8', display:'flex', alignItems:'center', gap:6 }}>
                  Intervalo entre avisos
                  <input type="number" min={0} max={1440} aria-label={`Intervalo de ${t.rotulo} em minutos`} value={t.intervalo_min} disabled={!dados.pode_editar || !t.ativo} style={{ width:70 }}
                    onChange={e => mudar(t.tipo, { intervalo_min: e.target.value })} /> min
                </label>
              </div>
            ))}
            <div style={{ fontSize:11, color:'#64748b', marginTop:8 }}>Intervalo: depois de um aviso, os próximos do mesmo tipo no mesmo veículo só avisam passado esse tempo (0 = avisa sempre).</div>
            {ok && <div role="status" style={{ color:'#4ade80', fontSize:12, marginTop:8 }}>✅ Salvo</div>}
            <div style={{ display:'flex', gap:8, justifyContent:'flex-end', marginTop:14 }}>
              <button className="btn btn-ghost" onClick={aoFechar}>Fechar</button>
              {dados.pode_editar && <button className="btn btn-primary" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando...' : '💾 Salvar'}</button>}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

// ---------------------------------------------------------------------------------------------
// Ranking de condução: pontos = colisão 10 + frenagem 2 + aceleração 1 + curva 1 (menos pontos = melhor)
// ---------------------------------------------------------------------------------------------
function RankingConducao() {
  const [dias, setDias] = useState(30)
  const [dados, setDados] = useState<any>(null)
  const [erro, setErro] = useState('')
  useEffect(() => {
    setDados(null); setErro('')
    axios.get(`${API}/alertas-conducao/ranking`, { params: { dias } }).then(r => setDados(r.data)).catch(e => setErro(erroMsg(e)))
  }, [dias])
  const th: any = { padding:'8px 12px', textAlign:'left', fontSize:11, color:'#64748b', fontWeight:600, textTransform:'uppercase' }
  const td: any = { padding:'10px 12px', fontSize:13 }
  return (
    <div>
      <div style={{ display:'flex', gap:12, alignItems:'center', marginBottom:12, flexWrap:'wrap' }}>
        <select aria-label="Período do ranking" value={dias} onChange={e => setDias(Number(e.target.value))} style={{ width:170 }}>
          <option value={7}>Últimos 7 dias</option><option value={30}>Últimos 30 dias</option><option value={90}>Últimos 90 dias</option>
        </select>
        <span style={{ fontSize:11, color:'#64748b' }}>Pontos: colisão 10 · frenagem brusca 2 · aceleração brusca 1 · curva brusca 1. Menos pontos é melhor. Corte de energia não conta.</span>
      </div>
      {erro && <div role="alert" style={{ color:'#f87171', fontSize:12, marginBottom:8 }}>⚠️ {erro}</div>}
      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', minWidth:720 }}>
            <thead><tr style={{ background:'#0d1b2e' }}>{['#','Motorista','Veículos','Frenagens','Acelerações','Curvas','Colisões','Pontos'].map((h,i) => <th key={i} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {!dados && !erro ? <tr><td colSpan={8} style={{ padding:24, textAlign:'center', color:'#64748b' }}>Carregando...</td></tr>
                : dados && dados.linhas.length === 0 ? <tr><td colSpan={8} style={{ padding:32, textAlign:'center', color:'#64748b' }}>Nenhum evento de condução neste período 🎉</td></tr>
                : dados?.linhas.map((l: any, i: number) => (
                  <tr key={l.motorista_id || 'sem'} style={{ borderTop:'1px solid rgba(45,65,102,0.4)' }}>
                    <td style={{ ...td, color:'#64748b' }}>{i + 1}</td>
                    <td style={{ ...td, fontWeight:600, color: l.motorista_id ? '#f1f5f9' : '#94a3b8' }}>{l.motorista_nome}</td>
                    <td style={{ ...td, fontSize:11, color:'#94a3b8' }}>{(l.veiculos || []).join(', ')}</td>
                    <td style={td}>{l.frenagens}</td><td style={td}>{l.aceleracoes}</td><td style={td}>{l.curvas}</td>
                    <td style={{ ...td, color: l.colisoes ? '#ef4444' : undefined, fontWeight: l.colisoes ? 700 : 400 }}>{l.colisoes}</td>
                    <td style={{ ...td, fontWeight:700, color: l.pontos >= 20 ? '#ef4444' : l.pontos >= 8 ? '#f59e0b' : '#22c55e' }}>{l.pontos}</td>
                  </tr>))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default function Alertas() {
  const [aba, setAba] = useState<'alertas'|'ranking'>('alertas')
  const [configAberta, setConfigAberta] = useState(false)
  const [alertas, setAlertas]   = useState<any[]>([])
  const [loading, setLoading]   = useState(true)
  const [filtroTipo, setFiltroTipo] = useState('todos')
  const [filtroLido, setFiltroLido] = useState('todos')
  const [busca, setBusca]       = useState('')
  const [pagina, setPagina]     = useState(1)
  const POR_PAGINA = 20

  useEffect(() => { carregar() }, [])

  const carregar = async () => {
    try {
      const r = await axios.get(`${API}/alertas`)
      setAlertas(r.data)
    } catch { setAlertas([]) }
    finally { setLoading(false) }
  }

  const marcarLido = async (id: number) => {
    try {
      await axios.put(`${API}/alertas/${id}/lido`)
      setAlertas(a => a.map(x => x.id === id ? {...x, lido:true} : x))
    } catch {}
  }

  const marcarTodosLidos = async () => {
    try {
      await axios.put(`${API}/alertas/todos-lidos`)
      setAlertas(a => a.map(x => ({...x, lido:true})))
    } catch {}
  }

  const tipos = ['todos', ...Array.from(new Set(alertas.map(a => a.tipo_alerta)))]

  const filtrados = alertas.filter(a => {
    const matchTipo  = filtroTipo === 'todos' || a.tipo_alerta === filtroTipo
    const matchLido  = filtroLido === 'todos' || (filtroLido === 'nao_lido' ? !a.lido : a.lido)
    const matchBusca = !busca || a.descricao?.toLowerCase().includes(busca.toLowerCase()) ||
                       a.ativo_nome?.toLowerCase().includes(busca.toLowerCase())
    return matchTipo && matchLido && matchBusca
  })

  const naoLidos    = alertas.filter(a => !a.lido).length
  const paginados   = filtrados.slice((pagina-1)*POR_PAGINA, pagina*POR_PAGINA)
  const totalPaginas = Math.ceil(filtrados.length / POR_PAGINA)

  return (
    <div style={{ padding:24, overflowY:'auto', height:'100%' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:20, fontWeight:700 }}>Alertas</h2>
          <p style={{ fontSize:13, color:'#64748b' }}>
            {alertas.length} total · <span style={{ color:'#ef4444' }}>{naoLidos} não lidos</span>
          </p>
        </div>
        <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
          <button className="btn btn-ghost" onClick={() => setConfigAberta(true)}>⚙️ Avisos de condução</button>
          <button className="btn btn-ghost" onClick={carregar}>🔄 Atualizar</button>
          {naoLidos > 0 && (
            <button className="btn btn-primary" onClick={marcarTodosLidos}>✓ Marcar todos como lidos</button>
          )}
        </div>
      </div>

      <div style={{ display:'flex', gap:6, marginBottom:16 }}>
        <button className={aba === 'alertas' ? 'btn btn-primary' : 'btn btn-ghost'} onClick={() => setAba('alertas')}>🔔 Alertas</button>
        <button className={aba === 'ranking' ? 'btn btn-primary' : 'btn btn-ghost'} onClick={() => setAba('ranking')}>🏆 Ranking de condução</button>
      </div>
      {aba === 'ranking' && <RankingConducao />}
      {configAberta && <ConfigConducao aoFechar={() => setConfigAberta(false)} />}
      {aba === 'alertas' && (<>

      {/* Filtros */}
      <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
        <input placeholder="Buscar alerta ou veículo..."
          value={busca} onChange={e => { setBusca(e.target.value); setPagina(1) }}
          style={{ width:250 }} />

        <select value={filtroLido} onChange={e => { setFiltroLido(e.target.value); setPagina(1) }}
          style={{ width:150 }}>
          <option value="todos">Todos</option>
          <option value="nao_lido">Não lidos</option>
          <option value="lido">Lidos</option>
        </select>

        <select value={filtroTipo} onChange={e => { setFiltroTipo(e.target.value); setPagina(1) }}
          style={{ width:200 }}>
          {tipos.map(t => <option key={t} value={t}>{t === 'todos' ? 'Todos os tipos' : rotuloTipo(t)}</option>)}
        </select>
      </div>

      {/* Cards de resumo por tipo */}
      <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
        {[
          { tipo:'excesso_velocidade', label:'Velocidade',   cor:'#ef4444' },
          { tipo:'area_proibida',      label:'Área proibida',cor:'#dc2626' },
          { tipo:'sem_comunicacao',    label:'Sem sinal',    cor:'#f59e0b' },
          { tipo:'fora_horario',       label:'Fora horário', cor:'#f59e0b' },
          { tipo:'manutencao_hodometro',label:'Manutenção',  cor:'#8b5cf6' },
          { tipo:'colisao',            label:'Colisão',      cor:'#ef4444' },
          { tipo:'frenagem_brusca',    label:'Frenagem',     cor:'#f59e0b' },
          { tipo:'aceleracao_brusca',  label:'Aceleração',   cor:'#f59e0b' },
          { tipo:'curva_brusca',       label:'Curva',        cor:'#f59e0b' },
          { tipo:'corte_energia',      label:'Energia',      cor:'#f59e0b' },
        ].map(s => {
          const qtd = alertas.filter(a => a.tipo_alerta === s.tipo && !a.lido).length
          if (qtd === 0) return null
          return (
            <div key={s.tipo} onClick={() => { setFiltroTipo(s.tipo); setPagina(1) }}
              style={{ background:'#1e2f4a', border:`1px solid ${s.cor}44`, borderRadius:8,
                padding:'6px 12px', cursor:'pointer', display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:16 }}>{ICONES[s.tipo]}</span>
              <div>
                <div style={{ fontSize:16, fontWeight:700, color:s.cor }}>{qtd}</div>
                <div style={{ fontSize:10, color:'#64748b' }}>{s.label}</div>
              </div>
            </div>
          )
        })}
      </div>

      {/* Lista */}
      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        {loading ? (
          <div style={{ padding:32, textAlign:'center', color:'#64748b' }}>Carregando...</div>
        ) : paginados.length === 0 ? (
          <div style={{ padding:48, textAlign:'center' }}>
            <div style={{ fontSize:40, marginBottom:12 }}>🔔</div>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:8 }}>Nenhum alerta encontrado</div>
            <div style={{ fontSize:13, color:'#64748b' }}>Os alertas aparecerão aqui quando forem disparados</div>
          </div>
        ) : paginados.map((a: any) => (
          <div key={a.id} style={{
            display:'flex', alignItems:'flex-start', gap:12, padding:'12px 16px',
            borderBottom:'1px solid rgba(45,65,102,0.4)',
            background: a.lido ? 'transparent' : 'rgba(14,165,233,0.04)',
            borderLeft: a.lido ? '3px solid transparent' : '3px solid #0ea5e9'
          }}>
            <span style={{ fontSize:22, flexShrink:0, marginTop:2 }}>{ICONES[a.tipo_alerta] || '🔔'}</span>
            <div style={{ flex:1 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
                <div>
                  <span className={`badge badge-${CORES[a.tipo_alerta] || 'cinza'}`} style={{ fontSize:10, marginRight:8 }}>
                    {rotuloTipo(a.tipo_alerta)}
                  </span>
                  {!a.lido && <span className="badge badge-azul" style={{ fontSize:9 }}>NOVO</span>}
                </div>
                <span style={{ fontSize:11, color:'#475569' }}>
                  {new Date(a.criado_em).toLocaleString('pt-BR')}
                </span>
              </div>
              <div style={{ fontSize:13, color:'#f1f5f9', marginBottom:2 }}>
                <strong style={{ color:'#38bdf8' }}>{a.ativo_nome || 'Veículo'}</strong>
                {a.descricao && ` — ${a.descricao}`}
              </div>
              {a.endereco && (
                <div style={{ fontSize:11, color:'#475569' }}>📍 {a.endereco}</div>
              )}
              {(a.latitude && a.longitude) && (
                <div style={{ fontSize:11, color:'#334155' }}>
                  🌐 {parseFloat(a.latitude).toFixed(6)}, {parseFloat(a.longitude).toFixed(6)}
                </div>
              )}
            </div>
            {!a.lido && (
              <button className="btn btn-ghost" style={{ fontSize:11, padding:'4px 8px', flexShrink:0 }}
                onClick={() => marcarLido(a.id)}>✓ Lido</button>
            )}
          </div>
        ))}
      </div>

      {/* Paginação */}
      {totalPaginas > 1 && (
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:16 }}>
          <button className="btn btn-ghost" disabled={pagina===1} onClick={() => setPagina(p=>p-1)}>← Anterior</button>
          <span style={{ padding:'8px 16px', color:'#94a3b8', fontSize:13 }}>
            Página {pagina} de {totalPaginas}
          </span>
          <button className="btn btn-ghost" disabled={pagina===totalPaginas} onClick={() => setPagina(p=>p+1)}>Próxima →</button>
        </div>
      )}
      </>)}
    </div>
  )
}
